import React, { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import { useCallback } from "react";

import "bootstrap/dist/css/bootstrap.min.css";

const GestionarPlan = () => {

  const { id } = useParams();
  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [componentName, setComponentName] = useState("");
  const [porcentaje, setPorcentaje] = useState("");
  const [componentes, setComponentes] = useState([]);
  const [fases, setFases] = useState({});
  const [selectedComponent, setSelectedComponent] = useState(null);

  const [faseName, setFaseName] = useState("");
  const [fasePorcentaje, setFasePorcentaje] = useState("");
  const [totalActividades, setTotalActividades] = useState("");

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [totalComponentes, setTotalComponentes] = useState(0);

//   Actividades
    const [actividades, setActividades] = useState({});
    const [selectedFase, setSelectedFase] = useState(null);
    const [actividadName, setActividadName] = useState({});
    const [totalEntregables, setTotalEntregables] = useState({});


const [avancePlan, setAvancePlan] = useState(0);
const [plan, setPlan] = useState(null);


  // =========================
  // MENSAJES 5 SEGUNDOS
  // =========================
  useEffect(() => {
    if (!error && !success) return;
    const timer = setTimeout(() => {
      setError("");
      setSuccess("");
    }, 5000);
    return () => clearTimeout(timer);
  }, [error, success]);

  // =========================
  // CARGAR COMPONENTES
  // =========================
  const loadComponentes = useCallback(async () => {
  const res = await authFetch(
    `${ENDPOINTS.get_componentes}?id_plan=${id}`
  );
  if (res.success) {
    setComponentes(res.data);
    setAvancePlan(res.avance_plan);
    setPlan(res.plan); // 👈 NUEVO

    const total = res.data.reduce(
      (sum, c) => sum + parseFloat(c.porcentaje),
      0
    );

    setTotalComponentes(total);
  }

}, [authFetch, id]);
useEffect(() => {
  loadComponentes();
}, [loadComponentes]);


  // =========================
  // CARGAR FASES
  // =========================
  const loadFases = async (componentId) => {
    const res = await authFetch(
      `${ENDPOINTS.get_fases}?id_component=${componentId}`
    );

    if (res.success) {
      setFases(prev => ({
        ...prev,
        [componentId]: res.data
      }));
    }
  };
  // =========================
  // CARGAR ACTIVIDADES
  // =========================
  const loadActividades = async (faseId) => {
  const res = await authFetch(
    `${ENDPOINTS.get_actividades}?id_fase=${faseId}`
  );

  if (res.success) {
    setActividades(prev => ({
      ...prev,
      [faseId]: res.data || []
    }));
  }
};


  // =========================
  // CREAR COMPONENTE
  // =========================
  const handleCreateComponent = async (e) => {
    e.preventDefault();

    const res = await authFetch(ENDPOINTS.create_componente, {
      method: "POST",
      body: JSON.stringify({
        id_plan: id,
        component: componentName,
        porcentaje: porcentaje
      })
    });

    if (!res.success) {
      setError(res.message);
      return;
    }

    setSuccess("Componente creado correctamente");
    setComponentName("");
    setPorcentaje("");
    loadComponentes();
  };

  // =========================
  // CREAR FASE
  // =========================
  const handleCreateFase = async (e) => {
    e.preventDefault();

    if (!totalActividades || totalActividades <= 0) {
      setError("Debe definir la cantidad de actividades");
      return;
    }

    const res = await authFetch(ENDPOINTS.create_fase, {
      method: "POST",
      body: JSON.stringify({
        id_plan: id,
        id_component: selectedComponent,
        name: faseName,
        porcentaje: fasePorcentaje,
        total_actividades: totalActividades
      })
    });

    if (!res.success) {
      setError(res.message);
      return;
    }

    setSuccess("Fase creada correctamente");
    setFaseName("");
    setFasePorcentaje("");
    setTotalActividades("");

    loadFases(selectedComponent);
  };

//   CREAR ACTIVIDADES
const handleCreateActividad = async (e, fase) => {
  e.preventDefault();

  const nombre = actividadName[fase.id];
  const entregables = totalEntregables[fase.id];

  if (!nombre || nombre.trim() === "") {
    setError("Debe ingresar el nombre de la actividad");
    return;
  }

  if (!entregables || entregables <= 0) {
    setError("Debe definir la cantidad de entregables");
    return;
  }

  const res = await authFetch(ENDPOINTS.create_actividad, {
    method: "POST",
    body: JSON.stringify({
      id_fase: fase.id,
      name_activity: nombre,
      total_entregables: entregables
    })
  });

  if (!res.success) {
    setError(res.message);
    return;
  }

  setSuccess("Actividad creada correctamente");

  // limpiar solo esa fase
  setActividadName(prev => ({
    ...prev,
    [fase.id]: ""
  }));

  setTotalEntregables(prev => ({
    ...prev,
    [fase.id]: ""
  }));

  loadActividades(fase.id);
};



return (
  <div className="container mt-4 p-4">

    <h3 className="mb-2">Gestionar Plan de Acción</h3>

    {plan && (
      <div>
        <div className="text-muted small fw-bold">
          {plan.name} | ID: {plan.id}
        </div>
      </div>
    )}
    <div className="fw-bold text-success">
      Avance general: {avancePlan}%
    </div>



    {error && <div className="alert alert-danger">{error}</div>}
    {success && <div className="alert alert-success">{success}</div>}

    {/* ================= CREAR COMPONENTE ================= */}
    <div className="card p-4 mb-4 shadow-sm">
      <h5 className="mb-3">Crear Componente</h5>

      <form onSubmit={handleCreateComponent}>
        <div className="row g-3">

          <div className="col-md-6">
            <input
              className="form-control"
              placeholder="Nombre del componente"
              value={componentName}
              onChange={(e) => setComponentName(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <input
              type="number"
              className="form-control"
              placeholder="% del plan"
              min="1"
              value={porcentaje}
              onChange={(e) => setPorcentaje(e.target.value)}
            />
          </div>

          <div className="col-md-3">
            <button className="btn btn-outline-pink w-100">
              Crear Componente
            </button>
          </div>

        </div>
      </form>
    </div>

    {/* ================= LISTA COMPONENTES ================= */}
    {componentes.map((comp) => (
      <div key={comp.id} className="card p-4 mb-4 shadow-sm">

        {/* HEADER COMPONENTE */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="mb-0">
              {comp.component}
            </h5>

            <div className="small mt-1">
              <span className="text-muted">
                Base: {comp.porcentaje}%
              </span>

              {" — "}

              <span className="fw-semibold text-warning">
                Avance fases: {comp.avance_interno}%
              </span>

              {" — "}

              <span className="fw-bold text-primary">
                Aporte real: {comp.aporte_real}%
              </span>
            </div>

          </div>

          <button
            className="btn btn-outline-secondary btn-sm"
            disabled={totalComponentes !== 100}
            onClick={() => {
              setSelectedComponent(comp.id);
              loadFases(comp.id);
            }}
          >
            Crear Fase
          </button>
        </div>

        {totalComponentes !== 100 && (
          <div className="alert alert-warning">
            Debe completar el 100% de los componentes antes de crear fases
          </div>
        )}

        {/* ================= FORM FASE ================= */}
        {selectedComponent === comp.id && (
          <div className="card bg-light p-3 mb-3">
            <h6 className="mb-3">Nueva Fase</h6>

            <form onSubmit={handleCreateFase}>
              <div className="row g-3">

                <div className="col-md-4">
                  <input
                    className="form-control"
                    placeholder="Nombre de fase"
                    value={faseName}
                    onChange={(e) => setFaseName(e.target.value)}
                  />
                </div>

                <div className="col-md-2">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="% Fase"
                    min="1"
                    value={fasePorcentaje}
                    onChange={(e) => setFasePorcentaje(e.target.value)}
                  />
                </div>

                <div className="col-md-3">
                  <input
                    type="number"
                    className="form-control"
                    placeholder="N° Actividades"
                    min="1"
                    value={totalActividades}
                    onChange={(e) => setTotalActividades(e.target.value)}
                  />
                </div>

                <div className="col-md-3">
                  <button className="btn btn-outline-pink w-100">
                    Guardar Fase
                  </button>
                </div>

              </div>
            </form>
          </div>
        )}

        {/* ================= LISTA FASES ================= */}
        {fases[comp.id] && fases[comp.id].length > 0 && (
          <div className="mt-3">

            {fases[comp.id].map((fase) => (
                
            <div key={fase.id} className="card p-3 mb-3 border-start border-4 border-purple">

                <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <strong>{fase.name}</strong>

                      <div className="small mt-1">
                        
                        <span className="text-muted">
                          Base: {fase.porcentaje}%
                        </span>

                        {" — "}

                        <span className="fw-semibold text-warning">
                          Avance actividades: {fase.avance_interno}%
                        </span>

                        {" — "}

                        <span className="fw-bold text-primary">
                          Aporte real: {fase.aporte_real}%
                        </span>

                        {" — "}

                        <span className="text-muted">
                          {fase.total_actividades} actividades
                        </span>

                      </div>
                    </div>

                    <button
                        className="btn btn-sm btn-outline-dark"
                        onClick={() => {
                            setSelectedFase(fase.id);
                            loadActividades(fase.id);
                        }}>
                        Crear Actividad
                    </button>
                </div>

                {/* FORM ACTIVIDAD */}
                {selectedFase === fase.id && (
                <form
                    className="row mt-3"
                    onSubmit={(e) => handleCreateActividad(e, fase)}
                >
                    <div className="col-md-6">
                    <input
                        className="form-control"
                        placeholder="Nombre de actividad"
                        value={actividadName[fase.id] || ""}
                        onChange={(e) =>
                        setActividadName(prev => ({
                            ...prev,
                            [fase.id]: e.target.value
                        }))
                        }
                    />
                    </div>

                    <div className="col-md-3">
                    <input
                        type="number"
                        className="form-control"
                        placeholder="N° Entregables"
                         min="1"
                        value={totalEntregables[fase.id] || ""}
                        onChange={(e) =>
                        setTotalEntregables(prev => ({
                            ...prev,
                            [fase.id]: e.target.value
                        }))
                        }
                    />
                    </div>

                    <div className="col-md-3">
                    <button className="btn btn-outline-pink w-100">
                        Guardar Actividad
                    </button>
                    </div>
                </form>
                )}

                {/* LISTA ACTIVIDADES */}
                {actividades[fase.id] && actividades[fase.id].length > 0 && (
                  actividades[fase.id].map((act) => {

                    // 🔢 Cálculo del aporte real ponderado
                    const avancePonderado =
                      (parseFloat(act.porcentaje || 0) *
                      parseFloat(act.avance_actividad || 0)) / 100;

                    return (

                      <div
                        key={act.id}
                        className="p-3 mb-3 bg-light border rounded"
                      >
                        <div className="row align-items-start">

                          {/* COLUMNA CONTENIDO */}
                          <div className="col-md-9">

                            <strong>{act.name_activity}</strong>

                            <div className="text-muted small mb-2">
                              Base: {act.porcentaje}% |{" "}
                              {act.total_entregables} entregable |{" "}
                              Avance físico: {act.avance_actividad}% |{" "}
                              Aporte real:{" "}
                              <span className="fw-bold text-dark">
                                {avancePonderado.toFixed(2)}%
                              </span>
                            </div>

                            <div className="progress" style={{ height: "18px" }}>
                              <div
                                className={`progress-bar ${
                                  act.avance_actividad === 100
                                    ? "bg-success"
                                    : act.avance_actividad > 0
                                    ? "bg-warning"
                                    : "bg-secondary"
                                }`}
                                style={{ width: `${act.avance_actividad}%` }}
                              >
                                {act.avance_actividad}%
                              </div>
                            </div>

                          </div>

                          {/* COLUMNA BOTÓN */}
                          <div className="col-md-3 text-end">
                            <button
                              className="btn btn-sm btn-outline-purple"
                              onClick={() =>
                                navigate(`/session/plan_accion/gestionar_actividad/${act.id}`)
                              }
                            >
                              Gestionar
                            </button>
                          </div>

                        </div>
                      </div>

                    );
                  })
                )}

                </div>

            ))}

          </div>
        )}

      </div>
    ))}

  </div>
);

};

export default GestionarPlan;
